import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Cookies from 'universal-cookie';
import FilterListIcon from '@material-ui/icons/FilterList';
import GetCompaniesExcel from '../../services/getCompaniesExcel';
import investorExcel from '../../utils/excel/investorExcel';
import Utils from '../../utils/utils';
import CheckBox from '../CheckBox';


import {
  Event as ScheduleIcon,
  PictureAsPdf as PdfIcon,
  GridOn as ExcelIcon,
  Mail as MailIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";
import "./style.css";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy].toLowerCase() < a[orderBy].toLowerCase()) {
    return -1;
  }
  if (b[orderBy].toLowerCase() > a[orderBy].toLowerCase()) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = props.headCells;

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{fontWeight: 'bold'}}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

//create your forceUpdate hook
function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => value + 1); // update the state to force render
}

var searchText = '';


export default function EnhancedTable(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('company');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  var rows = props.rows;

  if (searchText != ''){
    rows = [];
    props.rows.forEach(r => {
      var found = false;
      var lowerSearch = searchText.toLowerCase();
      if (r.company.toLowerCase().indexOf(lowerSearch) != -1) found = true;
      if (r.brokerName.toLowerCase().indexOf(lowerSearch) != -1) found = true;
      if (r.name.toLowerCase().indexOf(lowerSearch) != -1) found = true;
      if (found == true)
        rows.push(r);
    });
  }
  
  const forceUpdate = useForceUpdate();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.eventName);
   //   setSelected(newSelecteds);
      return;
    }
 //   setSelected([]);
  };

  const handleChange = (e) => {
    console.log(e.target.value)
    searchText = e.target.value;
    forceUpdate();

  }


  const resetSearch = () => {
    if (searchRef.current != null){
      searchRef.current.value = '';
      searchText = '';
    }
    forceUpdate();
  }

  const handleClick = (row, name) => {
    
    props.onEventClick(row.id);

    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

 //   setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    if (props.onResetCheckList)
      props.onResetCheckList();
    
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };



  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  var searchRef = React.createRef();

  return (
    <div className={classes.root}>

      <div style={{marginBottom: 10, display: "inline-flex"}}>
        Search: 
        <input ref={searchRef} value={searchText} style={{marginLeft: 10}} type="text" onChange={(e) => {handleChange(e)}}></input>
        <div style={{marginLeft: 10, cursor: "pointer"}} onClick={resetSearch}>X</div>
      </div>

      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              headCells={props.headCells}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.eventName);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover                      
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <CheckBox elementId={row.id} onElementCheck={props.onElementCheck}/>
                      </TableCell> 
                      <TableCell onClick={(event) => handleClick(row, row.eventName)} component="th" id={labelId} scope="row" padding="none">
                        {row.company}
                      </TableCell>
                      <TableCell onClick={(event) => handleClick(row, row.eventName)} component="th" id={labelId} scope="row" padding="none">
                        {row.name}
                      </TableCell>
                      <TableCell onClick={(event) => handleClick(row, row.eventName)} component="th" id={labelId} scope="row" padding="none">
                        {row.brokerName}
                      </TableCell>
                      <TableCell onClick={(event) => handleClick(row, row.eventName)} align="right">{row.country}</TableCell>
                      <TableCell onClick={(event) => handleClick(row, row.eventName)} align="right">{row.phone_number}</TableCell>
                      <TableCell onClick={(event) => handleClick(row, row.eventName)} align="right">{row.email_address}</TableCell>
                      <TableCell align="right" className="iconsColumn">
                        <ScheduleIcon className="icon" style={{marginRight: 20, height: '20px', width: '20px'}} onClick={() => {
                          if (props.brokersInvestorViewEnabled && props.brokersInvestorViewEnabled == 0){
                            alert ('You are not yet allowed to see this schedule');
                            return;
                          }
                          const cookies = new Cookies();
                          cookies.set('scheduleType', 'investor', { path: '/' });
                          cookies.set('scheduleSubject', row.id, { path: '/' });
                          cookies.set('brokerFlag', props.broker ? props.broker : false, { path: '/' });
                          window.location.href= '#/app/schedule';
                        } }/>
                        <PdfIcon className="icon" style={{height: '20px', width: '20px'}} onClick={() => {
                          if (props.brokersInvestorViewEnabled && props.brokersInvestorViewEnabled == 0){
                            alert ('You are not yet allowed to see this schedule');
                            return;
                          }

                          const cookies = new Cookies();
                          cookies.set('scheduleType', 'investor', { path: '/' });
                          cookies.set('scheduleSubject', row.id, { path: '/' });
//                          window.location.href= '#/app/pdfPage';
                          Utils.goToPdfPage();
                        }}/>
                        <ExcelIcon style={{height: '20px', width: '20px'}} className="icon" onClick={() => {
                          if (props.brokersInvestorViewEnabled && props.brokersInvestorViewEnabled == 0){
                            alert ('You are not yet allowed to see this schedule');
                            return;
                          }

                                                    
                          const cookies = new Cookies();
                          cookies.set('scheduleType', 'investor', { path: '/' });
                          cookies.set('scheduleSubject', row.id, { path: '/' });
                          investorExcel();
                        }}
                        />
                        {props.broker != true && <MailIcon style={{height: '20px', width: '20px'}} className="icon" onClick={() => props.onSendMail(row.id)} />}
                        {props.broker != true && <DeleteIcon style={{height: '20px', width: '20px'}} className="icon" onClick={() => props.onDelete(row.id)} />}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={25}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>

    </div>
  );
}